/*eslint-disable */

import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import { bus } from '@/main';
import {
mapGetters,
} from 'vuex';

const $ = window.jQuery = require('jquery');  



export default {
  name: 'dashboard-left-sidebar',
  components: {},
  props: [],
  data () {
    return {
      userDetails:null,
      NotificationMsg:'',
      connectionRequest:'',
      connectionRequestCheck:'',
      NotificationMsgCheck: '',
      supportNotificationMsg:''
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'workspaceUserNotificationGetters'
    ]),
    getSelfUserDetailsFun(){
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getReqNotificationCountMethod(){
      return this.$store.getters.workspaceUserNotificationGetters;
    }
  },
  mounted () {
    this.getSelfUserDetailsFun
    bus.$on('userFriendRequest', (data) => {
      this.checkingUserReqNotificationMethod();
    });
    bus.$on('userFriendRequestClear', (data) => {
      this.connectionRequestCheck = 0;
    });
    bus.$on('updateMessageNotifications', (data) => {
      if(data.lbilWorkspace == 'yes') return;
      if(window.location.pathname.indexOf('workspace') == -1) {
        if(data.totalUnreadCount > 0){
          if(Push.Permission.has()){
            Push.create(data.msgSenderFullName, {
              body:data.senderMsgData,
              timeout:4000,
              onClick: function () {
                  window.focus();
                  this.close();
              }
            })
            this.NotificationMsgCheck = data.totalUnreadCount;
          }else{
            this.NotificationMsgCheck = data.totalUnreadCount;
            this.playSound(audioPlay)
          }
        }
      }
    });
    bus.$on('clearMessageNotifications', (data) => {
      this.NotificationMsgCheck = 0;
    });
    this.chatBrowserNotificationFunction()
  },
  methods: {
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    chatBrowserNotificationFunction(){
      this.$store.dispatch('chatBroserNotificationFun').then((res)=>{
        this.NotificationMsg = res.data.data.message
        this.connectionRequest = res.data.data.connection_request
        bus.$emit('sChatMsgCountBus', (res.data.data.support_message))
        if(this.NotificationMsg != ''){
          this.NotificationMsgCheck = this.NotificationMsg
          this.playSound(audioPlay)
        }
        if(this.connectionRequest != ''){
          this.connectionRequestCheck = this.connectionRequest
        }
        }).catch((err)=>{
        })
     },
     checkingUserReqNotificationMethod(){
       this.$store.dispatch('chatBroserNotificationFun')
      },
  },
  watch:{
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    getReqNotificationCountMethod(newVal, oldVal){
      if(newVal && newVal.data){
        let newNotificationVal = newVal.data
        this.connectionRequestCheck = newNotificationVal.connection_request
      }
    }
  }
}